import { FC } from 'react';

import { GridRow, TableCell, TableHeader, TableRow, Text, useBreakpoint } from '@hh.ru/magritte-ui';

export const HEADER_COLUMNS: { title: string; width: number }[] = [
    {
        title: 'Промокод',
        width: 240,
    },
    {
        title: 'Статус',
        width: 140,
    },
    {
        title: 'Период',
        width: 140,
    },
    {
        title: 'Сумма бонусов',
        width: 140,
    },
    {
        title: 'Активировано',
        width: 140,
    },
    {
        title: 'Осталось',
        width: 140,
    },
    {
        title: 'На кого',
        width: 140,
    },
];

export const PromoCodeTableHeader: FC = () => {
    const { isMobile } = useBreakpoint();

    if (isMobile) {
        return (
            <GridRow>
                {HEADER_COLUMNS.map(({ title }) => (
                    <GridRow key={title}>
                        <Text style="secondary">{title}</Text>
                    </GridRow>
                ))}
            </GridRow>
        );
    }

    return (
        <TableHeader>
            <TableRow>
                {HEADER_COLUMNS.map(({ title, width }) => (
                    <TableCell Element="th" width={width} key={title} align="left">
                        <Text typography="label-3-regular" style="secondary">
                            {title}
                        </Text>
                    </TableCell>
                ))}
            </TableRow>
        </TableHeader>
    );
};
